// Picker search (Peter, 2026-09-13): the pill above the language / currency lists (components/picker-search).
// Typing filters every list inside the nearest .c-picker-search-scope: currency rows on name, code and symbol;
// language rows on the native name, the English name and the code; any other list's [data-picker-search-row] rows on
// their data-picker-search-text, else their text (the help centre's Activity FAQ, COOL 380). Case- and accent-insensitive. Where the
// input carries data-placeholder-<tab key> attributes the placeholder follows the modal's active header tab.
(function () {
    let englishLanguageNames = {
        en: 'English', da: 'Danish', nl: 'Dutch', fr: 'French', de: 'German', it: 'Italian', ja: 'Japanese',
        no: 'Norwegian', pt: 'Portuguese', es: 'Spanish', sv: 'Swedish'
    };
    let searchable = function (text) { // "Francais" finds "Français"
        return (text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    let filterRows = function (scope, query) {
        if (!scope) { return; } // a pill with no list to filter (the help centre's "Search for help", COOL 393)
        let q = searchable(query.trim());
        scope.classList.toggle('c-picker-search-active', q.length > 0); // the Activity FAQ shows matches past its first 9
        let lists = [
            [...scope.querySelectorAll('.c-checkbox-item')].map(function (row) { return { el: row, text: searchable(row.textContent) }; }),
            [...scope.querySelectorAll('.cool-gtranslate-wrapper a')].map(function (a) {
                return { el: a, text: searchable(a.textContent + ' ' + (englishLanguageNames[a.dataset.gtLang] || '') + ' ' + a.dataset.gtLang) };
            }),
            [...scope.querySelectorAll('[data-picker-search-row]')].map(function (row) {
                return { el: row, text: searchable(row.getAttribute('data-picker-search-text') || row.textContent) };
            })
        ];
        lists.forEach(function (rows) {
            let lastShown = null;
            rows.forEach(function (row) {
                let hide = q.length > 0 && row.text.indexOf(q) === -1;
                row.el.classList.toggle('c-hidden', hide);
                row.el.classList.remove('c-picker-last');
                if (!hide) { lastShown = row.el; }
            });
            if (lastShown && q.length > 0) { lastShown.classList.add('c-picker-last'); } // its divider goes, like :last-child
        });
    };
    let scopeOf = function (input) { return input.closest('.c-picker-search-scope'); };
    let syncPlaceholder = function (input) {
        let modal = input.closest('.c-modal-overlay') || document;
        let active = modal.querySelector('.c-tabs-item-active');
        let text = active ? input.getAttribute('data-placeholder-' + active.getAttribute('data-tab-item-key')) : null;
        if (text) { input.setAttribute('placeholder', text); }
    };

    jQuery(document).on('input', '.c-picker-search input', function () {
        filterRows(scopeOf(this), this.value);
    });
    jQuery(document).on('click', '.c-tabs-item', function () {
        let modal = this.closest('.c-modal-overlay');
        let input = modal ? modal.querySelector('.c-picker-search input') : null;
        if (input) { setTimeout(function () { syncPlaceholder(input); }, 0); } // after the tab script moved the active class
    });
    // a fresh list each time a modal with a picker search opens
    jQuery(document).on('tmModal_open_#c-language-modal tmModal_open_#c-currency-modal', function (e) {
        let id = e.type.replace('tmModal_open_', '');
        document.querySelectorAll(id + ' .c-picker-search input').forEach(function (input) {
            input.value = '';
            filterRows(scopeOf(input), '');
            setTimeout(function () { syncPlaceholder(input); }, 0);
        });
    });
})();
